export default "__VITE_ASSET__C0lGlGkK__"